import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { TaskActionModel } from '../../../../api/Argentia/endpoints/tasks/model/tasks'
import { EnumCommodity, ProcedureStates, ProcedureTypes } from '../../../../api/Argentia/enums'
import { EnumTareaAccion } from '../../../../api/oData/enums/enumTareaAccion'
import { ProcedureChangeStateFormDialog } from '../../../../components/shared/procedureChangeStateDialog/ProcedureChangeStateDialog'
import SimpleDialog from '../../../../components/shared/simpleDialog/simpleDialog'
import { StandardCard } from '../../../../components/shared/standardCard/standardCard'
import { ObjectionsModel } from '../../../invoicesPage/invoicesPage.Model'
import { ResolveObjectionsTable } from '../resolveObjectionsTable/ResolveObjectionsTable'
import { TaskActionsTable } from '../taskActionsTable/taskActionsTable'
import { ProcedureParameter } from '../../../../api/Argentia/endpoints/procedures'

interface TaskActionsCardProps {
  isLoading?: boolean
  data: TaskActionModel[]
  objectionData: ObjectionsModel[]
  procedureId?: number
  procedureState?: ProcedureStates
  procedureType: ProcedureTypes
  procedureParameters: ProcedureParameter[]
  commodity?: EnumCommodity
  taskId: number
  onResolveObjectionsClick?: (ids: number[]) => void
  onExecuteActionClick?: (taskId: number) => void
  onRedirectToLeadActionClick?: (taskId: number) => void
}

export const TaskActionsCard: React.FC<TaskActionsCardProps> = ({
  isLoading = false,
  data,
  objectionData,
  procedureId,
  procedureState,
  procedureType,
  procedureParameters,
  commodity,
  taskId,
  onResolveObjectionsClick,
  onExecuteActionClick,
  onRedirectToLeadActionClick
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'tasks', 'enums'])
  const history = useHistory()

  const [isResolveObjectionsOpen, setIsResolveObjectionsOpen] = useState(false)
  const [isRejectDialogOpen, setIsRejectDialogOpen] = useState(false)

  const handleResolveObjections = (ids: number[]) => {
    onResolveObjectionsClick?.(ids)
    closeDialog()
  }
  const closeDialog = () => {
    setIsResolveObjectionsOpen(false)
    setIsRejectDialogOpen(false)
  }

  const handleSelectActionModel = (row: { code: EnumTareaAccion }) => {
    switch (row.code) {
      case EnumTareaAccion.FIX_DISC_ATR:
      case EnumTareaAccion.FIX_DISC_ACTIVACION: {
        setIsResolveObjectionsOpen(true)
        break
      }
      case EnumTareaAccion.SWT_ANALISIS_RECHAZO: {
        setIsRejectDialogOpen(true)
        break
      }
      case EnumTareaAccion.REDIRECT_TO_LEAD: {
        onRedirectToLeadActionClick?.(taskId)
        break
      }
      default: {
        onExecuteActionClick?.(taskId)
        break
      }
    }
  }

  return (
    <>
      {procedureState !== ProcedureStates.Descartado && (
        <StandardCard title={t('tasks:components.taskActionsModal.title')} isLoading={isLoading}>
          <TaskActionsTable data={data} onSelectActionModel={handleSelectActionModel} />
        </StandardCard>
      )}

      <SimpleDialog
        open={isResolveObjectionsOpen}
        handleClose={closeDialog}
        title={t('tasks:components.resolveObjectionsTable.title')}
      >
        <ResolveObjectionsTable
          data={objectionData}
          onResolveObjections={handleResolveObjections}
        />
      </SimpleDialog>

      <ProcedureChangeStateFormDialog
        procedureState={procedureState!}
        procedureType={procedureType!}
        procedureParameters={procedureParameters!}
        commodity={commodity!}
        procedureId={procedureId!}
        originProcedureId={0}
        onClose={closeDialog}
        open={isRejectDialogOpen}
      />
    </>
  )
}
